export default __webpack_public_path__ + "static/salesforce-integration-for-personalized-travel-2be4a71925c37afa3ea5b704058edc0a.png";